import React, { Fragment, Component } from "react";
import { getHumanReadableDateTime, getRequest, postRequest } from "../../globalhelper/helper";
import Select from 'react-select';
import Datatable from "../../components/DataTable2";

class CrossTANRecomm extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            formData :{
                txnentity : '',
                txnentity_obj : '',
                // target_tan : '',
                // target_tan_obj : '',
                // source_tan : '',
                // source_tan_obj : '',
                bound_value : 10
            },
            columns : [
                {
                    name: 'Txn. ID',
                    selector: row => row.SK.split("#")[2],
                    sortable: true,
                    width : '300px'
                },
                {
                    name : "Status",
                    selector : row => {
                        row.Status = Number(row.Success || 0) + Number(row.Failed || 0) === Number(row.Total || 0) ? "Finished" : "In Progress";
                        return (<div style={{ alignContent : 'center', overflow : 'unset'}}>
                        <div className="row" align="center">
                            <div className="col-md-12">
                                <span className={ row.Status === "Finished" ? "batch warning alert-success" : "batch warning alert-warning"} > {row.Status} </span>
                            </div>
                        </div>
                    </div>)},
                    sortable : true,
                    width : '130px'
                },
                {
                    name: 'Counts',
                    selector: row => <div style={{ alignContent : 'center'}}>
                        <div className="row">
                            <div className="col-md-12">
                                <span title="Success" className={"batch warning alert-success"} > {row.Success || 0} </span>
                            {/* </div>
                            <div className="col-md-4"> */}
                                <span title="Failed" className={"batch warning alert-error"} > {row.Failed || 0} </span>
                            {/* </div>
                            <div className="col-md-4"> */}
                                <span title="Total" className={ "batch warning alert-info"} > {row.Total || 0} </span>
                            </div>
                        </div>

                    </div>,
                    width : '300px'
                },
                {
                    name: 'Date & Time',
                    selector: row => <div style={{ alignContent : 'center', overflow : 'unset'}}>
                        <div className="row">
                            <div className="col-md-12">
                                <span title="Start" className="batch warning alert-warning"> {getHumanReadableDateTime(row.Started)} </span>
                            {/* </div>
                            <div className="col-md-12"> */}
                                <span title="End" className="batch warning alert-info"> {getHumanReadableDateTime(row.Started)} </span>
                            </div>
                        </div>
                    </div>,
                    sortable: true,
                    width : '400px'
                },
            ],
            fetching : false,
            txnEntityList : [],
            tanList : [],
            txnList : [],
         };
    }

    getTxnEntityList = () => {
        getRequest('api/tds/getTxnEntityList').then(res => {
            if(res.type === 'success') {
                this.setState({
                    txnEntityList : JSON.parse(res.res.data)
                });
            }
        });
    }

    handleChange = (ev) => {
        let { formData } = this.state;
        let NAME = ev.target.name, VALUE = ev.target.value;
        console.log(NAME, VALUE)
        formData[NAME] = VALUE;
        if(NAME === 'txnentity_obj'){
            formData['txnentity'] = VALUE.value;
        }
        if(NAME === 'target_tan_obj'){
            formData['target_tan'] = VALUE;
        }
        if(NAME === 'source_tan_obj'){
            formData['source_tan'] = VALUE;
        }
        this.setState({
            ...this.state,
            formData
        // }, () => {
            // if(NAME === "txnentity_obj")
            // {
            //     this.getTansListForTxnEntity(this.state.formData.txnentity);
            // }
        });
    }

    getTansListForTxnEntity = () => {
        getRequest('api/tds/getTanListForTxnEntity?txnentity=' + this.state.formData.txnentity).then(res => {
            if(res.type === 'success') {
                this.setState({
                    tanList : JSON.parse(res.res.data)
                });
            }
        });
    }

    getTxnList = () => {
        this.setState({
            ...this.state,
            fetching : true 
        }, () => {

            getRequest('api/tds/getTxnList?PK=CROSS-TAN').then(res => {
                if(res.type === 'success') {
                    this.setState({
                        txnList : JSON.parse(res.res.data),
                        fetching : false,
                    });
                }
            });
        })
    }

    componentDidMount = () => {
        this.getTxnEntityList();
        this.getTxnList();
    }

    executeRecom = () => {
        const BODY = {
            tan : this.state.formData.tan,
            txnentity : this.state.formData.txnentity,
            bound_value : this.state.formData.bound_value
        }
        postRequest('api/tds/runCrossTANRecommendation', { data : JSON.stringify(BODY)}).then(res => {
            if(res.type === 'success') {
                window.location.reload();
            }
        });

    }

    render() { 
        return (  
            <Fragment>
                <form >
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Txn Entity</label>
                                <Select
                                    value={this.state.formData.txnentity_obj}
                                    onChange={(value) => this.handleChange({ target : { name : 'txnentity_obj', value } })}
                                    options={this.state.txnEntityList}
                                />
                            </div>
                        </div>
                        {/* <div className="col-md-3">
                            <div className="form-group">
                                <label>Source TAN</label>
                                <Select
                                    value={this.state.formData.source_tan_obj}
                                    onChange={(value) => this.handleChange({ target : { name : 'source_tan_obj', value } })}
                                    options={this.state.tanList}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>Target TAN</label>
                                <Select
                                    value={this.state.formData.target_tan_obj}
                                    onChange={(value) => this.handleChange({ target : { name : 'target_tan_obj', value } })}
                                    options={this.state.tanList}
                                />
                            </div>
                        </div> */}
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="bound_value" > Bound Value</label> <br />
                                <input type="number" name="bound_value" className="col-md-12" value={this.state.formData.bound_value} id="bound_value" onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <button type="button" className="btn btn-primary" style={{ marginTop : 33 }} disabled={this.state.formData.txnentity == ""} onClick={this.executeRecom} >Execute</button>
                        </div>
                    </div>
                </form>
                <div className="row">
                    <div className="col-md-12">
                        <Datatable columns={this.state.columns} title="Transactions" downloadable={false} loading={this.state.fetching} key={this.state.txnList} data={this.state.txnList} ></Datatable>
                    </div>
                </div>
            </Fragment>
        );
    }
}
 
export default CrossTANRecomm;